import RelationshipColumnCreator from "./RelationshipColumnCreator.js";
import RelationshipDetailCreator from "./RelationshipDetailCreator.js";
import RelationshipEditor from "./RelationshipEditor.js";
import Actions from "./actions/PluginSetup.js";
export default {
  install(molten) {
    molten.addPlugin('AttributeValueEditor', RelationshipEditor);
    RelationshipColumnCreator.install(molten);
    RelationshipDetailCreator.install(molten);
    Actions.install(molten);
  }
};